import { IUserSubscriptionModel } from "@nf/common";
import { useTranslation } from "next-i18next";

import { useSubscriptionPriceLabel } from "../../../../PaymentDetailType";

interface SubscriptionTrialInfoProps {
  subscription: IUserSubscriptionModel;
}

export const SubscriptionTrialInfo = ({
  subscription,
}: SubscriptionTrialInfoProps) => {
  const { t } = useTranslation("translations");
  const offerPrice = useSubscriptionPriceLabel(subscription);

  return (
    <>
      {t("web_my_account_subscription_trial_status", {
        date: subscription.ExpirationDateLabel,
        price: subscription.NextPaymentPrice,
        currency: subscription.NextPaymentCurrency,
      })}{" "}
      {offerPrice &&
        t("web_my_account_subscription_trial_next_renewal", { offerPrice })}
    </>
  );
};

export default SubscriptionTrialInfo;
